// Jev decision contract (RF-JEV-01..05; F08 decision D22 slice F). Only a test fake implements it until the official
// contract is known (BLOCKED-external). The schema accepts extra keys ON PURPOSE: whatever Jev suggests is parsed, then
// the domain policy (packages/domain/src/jev-policy.ts) applies only bounded impact/urgency and records every other
// field as rejected with a reason. Values are not range-checked here for the same reason.
import { z } from "zod";
import { RESOURCE_CLASSES } from "./enums.ts";

export const jevSuggestionSchema = z
  .object({
    dimensions: z
      .object({
        domain: z.string().max(100).optional(),
        impact: z.number().optional(),
        semantic_urgency: z.number().optional(),
        complexity: z.string().max(40).optional(),
        needs_browser: z.boolean().optional(),
        model_capability: z.string().max(100).optional(),
        splittable: z.boolean().optional(),
      })
      .catchall(z.unknown()),
    confidence: z.number(),
    suggested_role: z.string().max(64).optional(),
    suggested_capability_group: z.string().max(64).optional(),
    resource_class: z.enum(RESOURCE_CLASSES).optional(),
  })
  .catchall(z.unknown());
export type JevSuggestion = z.infer<typeof jevSuggestionSchema>;

/** What the scheduler sends: the task summary only (never secrets, never repository contents). */
export interface JevInput {
  taskId: string;
  title: string;
  description: string;
  type: string;
  risk: string;
  inputHash: string;
  policyVersion: string;
}

export type JevFailureKind = "unavailable" | "quota_exhausted" | "invalid_output" | "timeout";

export class JevCallError extends Error {
  readonly kind: JevFailureKind;
  constructor(kind: JevFailureKind, message: string) {
    super(message);
    this.name = "JevCallError";
    this.kind = kind;
  }
}

/** Engine port of the Jev decision service (a fake in tests; the real adapter is BLOCKED-external). */
export interface JevPort {
  suggest(input: JevInput, signal: AbortSignal): Promise<unknown>;
}
